import optimumIcon from "../../assets/icons/optimumIcon.svg";
import "./navBar.css";
import userProfileImage from "../../assets/icons/avatar.png";
import userProfileDownArrow from "../../assets/icons/white-arrow-down.svg";
import { useState, useEffect, useRef, useMemo } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import UserService from "../../keycloak/UserService";
import useRoleFunctions from "../../utils/roleFunctions";

export default function NavBar() {
  const [open, close] = useState(false);
  const dropdownRef = useRef();
  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();
  const { hasRequiredRoles } = useRoleFunctions();
  const urlParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );

  const openDropdown = () => {
    close(!open);
  };

  const logout = () => {
    localStorage.clear();
    UserService.doLogout({ redirectUri: window.location.origin });
    urlParams.delete("status");
    urlParams.delete("fromDate");
    urlParams.delete("toDate");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        close(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const roleValues = [
    {
      key: "list_plans",
      label: "Plans",
      path: ["/plans", "/create-plans", /^\/edit-plans\/\d+$/],
    },
    {
      key: "list_devices",
      label: "Devices",
      path: ["/devices", "/add-device", /^\/edit-device\/\d+$/],
    },
    {
      key: "list_addons",
      label: "Addons",
      path: ["/addons", "/create-addons", /^\/edit-addons\/\d+$/],
    },
  ];

  // Generate menu items based on roles
  const roleItems = roleValues
    .filter((role) => hasRequiredRoles([role.key]))
    .map((role, index) => {
      const isActive = role.path.some((p) =>
        typeof p === "string"
          ? p === location.pathname
          : p.test(location.pathname)
      );

      return (
        <div
          key={index}
          className={`menu-item ${isActive ? "active" : ""}`}
          onClick={() => navigate(role.path[0])}
        >
          {role.label}
        </div>
      );
    });

  return (
    <div className="navbar-container">
      <a href="/">
        <img alt="Optimum Icon" src={optimumIcon} />
      </a>
      <div className="menu-container">{roleItems}</div>{" "}
      {userData && (
        <button
          ref={dropdownRef}
          className="user-profile"
          onClick={openDropdown}
        >
          <img
            className="profile-icon"
            src={userProfileImage}
            alt="user profile image"
          />
          {userData && <p>{`${userData?.firstName} ${userData?.lastName}`}</p>}
          <img
            className="down-arrow"
            src={userProfileDownArrow}
            alt="down arrow"
          />
          {open && (
            <ul className="option-list">
              <li onClick={logout}>Logout</li>
            </ul>
          )}
        </button>
      )}
    </div>
  );
}
